import { render, staticRenderFns } from "./sso-wsfed.vue?vue&type=template&id=720fe658&"
import script from "./sso-wsfed.ts?vue&type=script&lang=ts&"
export * from "./sso-wsfed.ts?vue&type=script&lang=ts&"
import style0 from "./sso-wsfed.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports